// editor.service.ts
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class EditorService {
  private editorInstance: any;

  setEditorInstance(editor: any) {
    this.editorInstance = editor;
  }

  getEditorInstance() {
    return this.editorInstance;
  }
}